<template lang="pug">
  div.lottery-container
    .member-lottery-container(v-if="show&&!isNewVersion")
      .lottery-title
        .lottery-title-time
          .lottery-title 会员日日抽
          .lottery-time 每日{{lotteryData.lotteryTime}}开奖
        .lottery-record-entry(@click="clickLotteryRecord") 中奖记录
      .lottery-goods-container
        .lottery-good(v-for="(item, index) in lotteryData.prizeInfo")
          img.lottery-good-img(:src="item.icon")
          .lottery-good-info
            .count-limit {{item.dailyStock}}
            .good-name {{item.prizeName}}
            .good-button.flex-mid(
                @click="handleLotteryClick(item)"
                :class="getButtonStyle(item.status)"
              )
              img.lock(v-if="item.status === LOTTERY_PRIZE_STATUS.draw_limited " src="https://m.hellobike.com/resource/gallery/43/Jj_nGg5N_289102.png")
              span {{getButtonText(item)}}
    //- 新版本
    .new-lottery(
      v-if="lotteryGroupList && lotteryGroupList.length > 0 && isNewVersion"
    )
      div(
        v-if="showLighting"
        v-flash
        :class="showLighting?'new-lottery-guide':''"
        @click="handlePrevent"
      )
      .title(@click="clickLotteryRecord")
        .title-text 每日{{splitTime(lotteryData.lotteryTime)}}点开奖
        .title-action
            .check-more 更多
            .title-action-icon
      .swiper-container(@click="handleSwiperClick")
        .swiper-wrapper
          .swiper-slide.lottery-goods-container(
            v-for="(group, groupIndex) in lotteryGroupList"
          )
            .lottery-good(
              v-for="(item, index) in group.prizeList"
              :data-group-index="groupIndex"
              :data-item-index="index"
            )
              .lottery-img-container
                img.lottery-good-img(:src="getImageUrl(item.icon)")
                .count-limit-container
                  .count-limit {{ item.dailyStock }}
              .lottery-good-info
                .good-name {{ item.prizeName }}
                .good-button.flex-mid(:class="item.btnStyle")
                  img.lock(v-if="item.isLocked" :src="LockIcon")
                  .btn-text {{ item.btnName }}

    involvedDialog(
      :show.sync="showInvolvedDialog"
      :involovedData="involvedData"
    )
</template>

<script>
import Swiper from 'swiper';
import 'swiper/swiper.min.css';
import Lottie from '@/components/lottie';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import eventBus from '@/const/eventBus.js';
import { Storage } from '@/utils/storage';
import dayjs from 'dayjs';
import {
  hasCalendar,
  setCalendarSchedule,
  // openSystemSetting,
} from '@/utils/calender';
import Toast from '@/components/toast';
import { env } from '@hb/hbridge';
import { Navigator } from '@hb/h5-navigator';
import { joinLottery, lotteryPushNotify } from '@/api/vip';
import { safeJsonStringify } from '@/utils/tools';
import {
  getTokenAndLocation,
} from '@/utils';
import { getImageUrl } from '@/utils/image';
import config from '@/const/config';
import { GUID_STORAGE, LOTTERY_SUBSCRIBED } from '@/const/vip';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '@/utils/params';
import {
  LockIcon,
  HotRadioDoubleIcon,
  HotRadioTripleIcon,
} from '@/assets/imgAssets';
import { lotteryActivityAdapter } from '../../common/helper';
import couponsItems from './coupons-Items.vue';
import { LOTTERY_PRIZE_STATUS } from '../../consts.js';
import involvedDialog from './involved-dialog';

export default {
  components: {
    Lottie,
    couponsItems,
    involvedDialog,
  },
  props: {
    moduleData: {
      type: Object,
      default: () => { },
    },
    isNewVersion: {
      type: Boolean,
      default: false,
    },
    currentOrderOptType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      haveSubscribed: false,
      LOTTERY_PRIZE_STATUS,
      lotteryData: {},
      show: false,
      showInvolvedDialog: false,
      involvedData: {},
      showLighting: false,
      LockIcon,
      // 活动分组列表
      lotteryGroupList: [],
      // 抽奖活动swiper实例
      lotterySwiper: null,
      // 是否跳转中奖记录页
      isJumpRecordPage: false,
      // 是否是首次曝光
      isFirstExpose: true,
    };
  },
  computed: {
    ratioIcon() {
      /* 2倍 */
      if (this.lotteryData.ratio === 2) {
        return HotRadioDoubleIcon;
      } if (this.lotteryData.ratio === 3) {
        /* 3倍 */
        return HotRadioTripleIcon;
      }
      return '';
    },
  },
  watch: {
    moduleData: {
      deep: true,
      immediate: true,
      handler(data) {
        if (this.isNewVersion) {
          this.handleLotteryInfo(data);
        } else {
          this.handleData(data);
        }
      },
    },
  },
  created() {
    // 检查是否订阅提醒
    this.checkRemind();
  },
  async mounted() {
    this.getFatigue();
  },
  beforeDestroy() {
    // 组件销毁时清理swiper实例
    if (this.lotterySwiper && this.lotterySwiper.destroy) {
      try {
        this.lotterySwiper.destroy(true, true);
      } catch (error) {
        // 静默处理销毁错误
      }
    }
    this.lotterySwiper = null;
  },
  methods: {
    getImageUrl,
    // 获取抽奖活动信息
    async handleLotteryInfo(data) {
      // 抽奖活动数据适配
      const { lotteryData, lotteryGroupList } = lotteryActivityAdapter(data);
      this.lotteryData = lotteryData;
      this.lotteryGroupList = lotteryGroupList;

      if (this.lotteryGroupList.length > 1) {
        this.initSwiper();
      }
      // 抽奖活动曝光埋点
      this.handleModuleExpose();
    },
    // 初始化swiper
    initSwiper() {
      // 销毁之前swiper实例
      if (this.lotterySwiper && this.lotterySwiper.destroy) {
        try {
          this.lotterySwiper.destroy(true, true);
        } catch (error) {
          // 静默处理销毁错误
        }
      }
      // 初始化swiper
      this.$nextTick(() => {
        this.lotterySwiper = new Swiper('.swiper-container', {
          direction: 'horizontal',
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          loop: true,
          allowTouchMove: false, // 禁止触摸滑动
          simulateTouch: false, // 禁止模拟触摸
        });
      });
    },
    handlePrevent() {
      this.showLighting = false;
    },
    /** 获取疲劳度 */
    async getFatigue() {
      const storageRes = await Storage.getItem(GUID_STORAGE);
      // 当前时间的零点
      if (storageRes) {
        const currStart = dayjs().startOf('day').valueOf();
        const timeDiff = dayjs(currStart).diff(dayjs(storageRes.lastShowTime).valueOf(), 's');

        if (Storage.showTimes >= 3 || timeDiff < 0) {
          return;
        }
      }
      this.showLighting = true;
      Storage.setItem(GUID_STORAGE, {
        showTimes: storageRes ? storageRes.showTimes || 0 + 1 : 1,
        lastShowTime: dayjs().valueOf(),
      });
      setTimeout(() => {
        this.showLighting = false;
      }, 5000);
    },
    handleData(data) {
      if (!data || !Object.keys(data).length || !data.prizeInfo || !data.prizeInfo.length) {
        this.show = false;
        return;
      }
      const lotteryData = {
        ...data,
        lotteryTime: data.lotteryTime || '20:00',
        prizeInfo: (data.prizeInfo || []).map((item) => ({
          ...item,
          status: item.status || LOTTERY_PRIZE_STATUS.draw_limited,
          statusDesc: this.getButtonText(item),
          dailyStock: item.dailyStock || 0,
          icon: item.icon || '',
        })),
      };
      this.lotteryData = lotteryData;
      this.show = true;
      // this.loadUbt();
    },
    // 抽奖活动曝光埋点
    handleModuleExpose() {
      if (!this.isFirstExpose) return;
      this.isFirstExpose = false;
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_winning_Records',
        contentId: 'platform_winning_Records',
        exposureTimes: 1,
        businessInfo: {},
      });
      // 抽奖奖品曝光
      this.lotteryGroupList.forEach((item) => {
        const { prizeList = [] } = item || {};
        prizeList.forEach((prize) => {
          const status = this.handleStatus(prize);
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_VIPgift',
            contentId: 'platform_VIPgift',
            exposureTimes: 1,
            businessInfo: {
              activityStatus: status,
            },
          });
        });
      });
    },
    /** xx:00 -> xx  */
    splitTime(time) {
      return time ? time.split(':')[0] : '';
    },
    getButtonText(item) {
      const { status, statusDesc = '' } = item;
      // 参与抽奖且已设置提醒且app环境
      if (status === LOTTERY_PRIZE_STATUS.signed && env.isEasyBikeApp) {
        if (!this.isNewVersion) return '已设置提醒';
        return `${this.splitTime(this.lotteryData.lotteryTime)}点开奖`;
      }
      // 参与抽奖且非APP环境，不展示提醒，直接设置同开奖状态
      if (status === LOTTERY_PRIZE_STATUS.signed && !env.isEasyBikeApp) {
        if (this.isNewVersion) {
          return `${this.splitTime(this.lotteryData.lotteryTime)}点开奖`;
        }
        return `${this.lotteryData.lotteryTime} 点开奖`;
      }
      if (this.isNewVersion && statusDesc === '开奖提醒我') {
        return '开奖提醒';
      }
      return statusDesc;
    },
    handleLotteryClick(item) {
      const ubtStatus = this.handleStatus(item);
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_VIPgift',
        categoryId: 'platform',
        businessInfo: {
          activityStatus: ubtStatus,
        },
      });
      const { status } = item;
      if (status === LOTTERY_PRIZE_STATUS.draw_limited) {
        // 领券用券可抽奖
        eventBus.$emit('clickLockLottery');
      } else if (status === LOTTERY_PRIZE_STATUS.draw_access) {
        // 可抽奖
        this.joinLotteryDraw(item);
      } else if (status === LOTTERY_PRIZE_STATUS.signed) {
        // 已报名
        Toast.show('活动已参与，今日20点开奖');
      } else if (status === LOTTERY_PRIZE_STATUS.drawing) {
        // 抽奖中
        Toast.show('活动正在开奖中');
      }
    },
    async joinLotteryDraw(item = {}) {
      const { cityCode, adCode, token } = await getTokenAndLocation();
      const { campaignCode } = this.lotteryData;
      const { activityCode = '', lotteryExchangeProductIdList: lotteryExchangeProductId } = item;
      const param = {
        adCode,
        cityCode,
        token,
        campaignCode,
        lotteryExchangeProductId,
        activityCode,
        appCode: 'platform',
        batchNo: this.lotteryData.batchNo || '',
      };
      joinLottery(param)
        .then((res) => {
          if (res && res.data && Object.keys(res.data).length) {
            this.involvedData = res.data;
            this.showInvolvedDialog = true;
            // 设置日历提醒
            this.setRemind();
            // 刷新活动数据
            this.$emit('refreshData');
          } else {
            Toast.show('参与失败');
          }
        })
        .catch(() => {
          Toast.show('参与失败');
        });
    },
    clickLotteryRecord() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_winning_Records',
        categoryId: 'platform',
        businessInfo: {},
      });
      const recordUrl = `https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env === 'dev' ? 'fat' : config.env}/`}latest/index.html#/vip/v3/lotteryRecord`;
      // const recordUrl = 'http://172.17.179.122:1024/#/vip/v3/lotteryRecord';
      const url = ParamsUtil.addParams(recordUrl, {
        campaignCode: this.lotteryData.campaignCode || '',
        batchNo: this.lotteryData.batchNo || '',
        currentOrderOptType: this.currentOrderOptType !== undefined ? this.currentOrderOptType : null,
      });
      Navigator.go(url);
      this.isJumpRecordPage = true;
    },
    getButtonStyle(status) {
      if (status === LOTTERY_PRIZE_STATUS.signed && !env.isEasyBikeApp) {
        return 'grey';
      }
      if (status === LOTTERY_PRIZE_STATUS.draw_limited && this.isNewVersion) {
        return '';
      }

      switch (status) {
        case LOTTERY_PRIZE_STATUS.drawing:
          return 'disabled';
        case LOTTERY_PRIZE_STATUS.signed:
          return 'grey';
        case LOTTERY_PRIZE_STATUS.draw_limited:
          return 'disabled';
        default:
          return '';
      }
    },
    async checkRemind() {
      if (!env.isEasyBikeApp) return;
      const version = await getVersion();
      if (version < '6.46.0') return;
      try {
        // 过期清除
        const res = await Storage.getItem(LOTTERY_SUBSCRIBED);
        if (res) {
          this.haveSubscribed = true;
        }
      } catch {
        //
      }
    },
    /** 提醒抽奖 */
    async setRemind() {
      const version = await getVersion();
      // push
      if (this.isNewVersion && env.isEasyBikeApp) {
        const {
          cityCode, adCode, token, userNewId,
        } = await getTokenAndLocation();
        const { campaignCode, lotteryTime } = this.lotteryData;
        const param = {
          adCode,
          cityCode,
          token,
          userNewId,
          version,
          // 营销活动key
          campaignCode,
          systemCode: getSystemCode(),
          appCode: 'platform',
          // 通知时间
          notifyTime: lotteryTime,
          batchNo: this.lotteryData.batchNo || '',
        };
        await lotteryPushNotify(param);
      }

      // 日历
      if (!env.isEasyBikeApp) return;
      if (version < '6.46.0') return;
      if (this.haveSubscribed) return;

      const res = await hasCalendar({});
      if (res.hasPermission) {
        // this.writeNotice();
        this.writeNoticeOnce();
        return;
      }
      // ios直接尝试写入，调用日历api，以唤起日历权限授权
      if (env.isIOS) {
        // this.writeNotice();
        this.writeNoticeOnce();
      } else if (env.isAndroid) {
        // Toast.show('请在设置中开启日历权限!');
        // setTimeout(() => {
        //   openSystemSetting();
        // }, 1000);
      }
    },
    // 新增方法：获取指定日期的开始和结束时间
    getScheduleTime(dayOffset = 0) {
      const date = new Date();
      date.setDate(date.getDate() + dayOffset);
      return {
        startTime: Math.floor(new Date(date).setHours(20, 10, 0) / 1000),
        endTime: Math.floor(new Date(date).setHours(20, 20, 0) / 1000),
        title: '哈啰会员日日抽开奖啦，今日必抽，大奖等你拿！',
        notes: 'hellobike://hellobike.com/openWeb?webUrl=https%3A%2F%2Fm.hellobike.com%2FAppPlatformH5%2Flatest%2Findex.html%23%2Fvip%2FnewTransfer%3Fadsource%3Dchoujiang',
      };
    },
    /**
     * 只写入一次日历
     * 当前开奖时间之前，提醒当天
     * 当天开奖时间之后，提醒第二天
     */
    async writeNoticeOnce() {
      try {
        const { lotteryTime } = this.lotteryData;
        const todayStart = dayjs().startOf('day');
        const todayEnd = dayjs().endOf('day');
        // 当天开奖时间 ： 当天起始时间 + lotteryTime（20:00、21：00）
        const todayLotteryTime = dayjs(todayStart).add(lotteryTime.split(':')[0], 'hour');
        // 第二天开奖时间
        const nextLotteryTime = dayjs(todayLotteryTime).add(1, 'day');
        let res;
        // 是否第二天提醒
        let isRemindDayTomorrow = 0;
        // 当前时间 < 开奖时间 -> 提醒当天，成功，写入缓存，设置缓存失效时间为当天开奖时间
        if (dayjs().isBefore(dayjs(todayLotteryTime))) {
          res = await setCalendarSchedule({ ...this.getScheduleTime(0) });
          isRemindDayTomorrow = 0;
        } else if (dayjs().isAfter(dayjs(todayLotteryTime)) && dayjs().isBefore(todayEnd)) {
          // 开奖时间 > 当天时间 > 当天结束时间 -> 提醒第二天，成功，写入缓存，设置缓存失效时间为第二天开奖时间之后
          res = await setCalendarSchedule({ ...this.getScheduleTime(1) });
          isRemindDayTomorrow = 1;
        }
        // 提醒设置缓存 & 过期时间
        if (res.isSuccess) {
          Storage.setItem(
            LOTTERY_SUBSCRIBED,
            true,
            isRemindDayTomorrow
              ? new Date(nextLotteryTime)
              : new Date(todayLotteryTime),
          );
          this.haveSubscribed = true;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('添加日历失败的原因', e);
      }
    },
    async writeNotice() {
      try {
        let firstDaySuccess = false;

        // 统一处理7天的提醒
        for (let i = 0; i < 7; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          const res = await setCalendarSchedule({ ...this.getScheduleTime(i) });
          // 如果是第一天且成功，设置标志
          if (res.isSuccess) {
            const dateRange = this.getScheduleTime(i);
            const key = `${dateRange.startTime}${dateRange.endTime}${dateRange.title}`;
            Storage.setItem(key, true);
            if (i === 0) {
              firstDaySuccess = true;
            }
          }
        }
        // 如果第一天成功，显示提示
        if (firstDaySuccess) {
          this.haveSubscribed = true;
          Toast.show('添加日历提醒成功，将在开抢前10分钟提醒您');
        }
      } catch (e) {
        Toast.show('添加日历提醒失败');
        // eslint-disable-next-line no-console
        console.log('添加日历失败的原因', e);
      }
    },
    // 统一处理 status
    handleStatus(item = {}) {
      const prize = { ...item };
      let { status } = prize;
      if (status === LOTTERY_PRIZE_STATUS.signed && this.haveSubscribed) {
        status = LOTTERY_PRIZE_STATUS.signed_haveSubscribe;
      }
      return status || '';
    },
    // swiper事件代理处理点击
    handleSwiperClick(event) {
      try {
        // 查找最近的good-button元素
        const button = event.target.closest('.good-button');
        if (button) {
          // 查找最近的lottery-good元素来获取数据属性
          const lotteryGood = button.closest('.lottery-good');
          if (!lotteryGood) return;
          // 获取对应点击数据
          const { groupIndex, itemIndex } = lotteryGood.dataset || {};
          if (groupIndex !== undefined && itemIndex !== undefined) {
            const { prizeList = [] } = this.lotteryGroupList[groupIndex] || {};
            const item = prizeList[itemIndex];

            if (!item) return;
            this.handleLotteryClick(item);
          }
        } else {
          this.clickLotteryRecord();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('handleSwiperClick => error', safeJsonStringify(error));
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../../styles/index.less';

.member-lottery-container {
  margin: 0.08rem 0.12rem 0.12rem;
  padding: 0.11rem 0.14rem 0.13rem 0.15rem;
  border-radius: 0.14rem;
  background: linear-gradient(350deg, #fff 78.23%, #ffe2e2 98.4%);
  height: 1.14rem;
  font-family: PingFangSC, sans-serif;
  position: relative;

  * {
    white-space: nowrap;
  }

  .lottery-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lottery-title-time {
      display: flex;
      align-items: center;
      height: 0.22rem;

      .lottery-title {
        color: #242729;
        font-size: 0.16rem;
        font-weight: 600;
      }

      .lottery-time {
        margin-left: 0.08rem;
        color: #ff5526;
        font-size: 0.12rem;
        font-weight: 500;
      }
    }

    .lottery-record-entry {
      height: 0.17rem;
      line-height: 0.18rem;
      font-size: 0.12rem;
      font-weight: 500;
      color: #5a6066;
      // display: flex;
      // align-items: center;

      &::after {
        .arrow(0.06rem, #5a6066, 0.013rem);

        margin-bottom: 0.01rem;
        margin-left: 0.03rem;
        // display: block;
        // width: 0.1rem;
        // height: 0.1rem;
        content: "";
        border-color: #5a6066; // 覆盖颜色
        // right: 0.05rem; // 右侧间距调整
        // position: absolute;
        // top: 0;
      }
    }
  }

  .lottery-goods-container {
    margin-top: 0.07rem;
    display: flex;
    justify-content: space-between;

    .lottery-good {
      display: flex;

      .lottery-good-img {
        margin-top: 0.02rem;
        border-radius: 0.12rem;
        width: 0.64rem;
        height: 0.64rem;
        background-color: #fff;
      }

      .lottery-good-info {
        margin-left: 0.06rem;

        .count-limit {
          .ellipsis();

          height: 0.14rem;
          line-height: 0.14rem;
          color: #879099;
          font-size: 0.1rem;
          font-weight: 400;
          max-width: 0.88rem;
        }

        .good-name {
          .ellipsis();

          margin-top: 0.04rem;
          height: 0.16rem;
          font-size: 0.14rem;
          font-weight: 500;
          line-height: 0.16rem;
          color: #242729;
          max-width: 0.88rem;
        }

        .good-button {
          overflow: hidden;
          text-overflow: clip;
          margin-top: 0.04rem;
          width: 0.74rem;
          height: 0.24rem;
          padding: 0.03rem 0.07rem;
          gap: 0.01rem;
          border-radius: 0.06rem;
          background: #fa4614;
          color: #fff;
          font-size: 0.12rem;
          font-weight: 500;
          line-height: 0.24rem;

          img {
            width: 0.09rem;
            height: 0.11rem;
            margin: 0 0.02rem 0.01rem 0;
          }

          &.disabled {
            background-color: #fda185;
          }

          &.black {
            background-color: #242729;
          }

          &.grey {
            background-color: #bcc4cc;
          }
        }
      }
    }
  }
}

.new-lottery {
  overflow: hidden;
  border-radius: 0.14rem;
  background: linear-gradient(to bottom, rgba(255, 237, 228, 1) 0%, rgba(255, 255, 255, 1) 100%);
  width: 100%;
  height: 100%;
  position: relative;

  .new-lottery-guide {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0.16rem;
    position: absolute;
    top: 0;
    z-index: 9;
    padding: 0.08rem 0.1rem;

    &::after {
      content: '';
      background: url('https://m.hellobike.com/resource/gallery/59/TTL-IdPE_Group%201707483354.png?x-oss-process=image/quality,q_80');
      background-repeat: no-repeat;
      height: 0.51rem;
      width: 1.08rem;
      background-size: 100%;
      position: absolute;
      left: calc(50% - 0.5rem);
      top: calc(50% - 0.25rem);
    }
  }

  .title {
    padding: 0.09rem 0.08rem 0.04rem 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-text {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 0.14rem;
      color: #835555;
    }

    .title-action {
      display: flex;
      align-items: center;

      .check-more {
        font-size: 0.12rem;
        font-weight: 500;
        color: #5a6066;
        line-height: normal;
      }

      .title-action-radio {
        height: 0.17rem;
        width: 0.2rem;
        margin-bottom: 0.04rem;
      }

      .title-action-icon {
        width: 0.12rem;
        height: 0.12rem;
        background-image: url('https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-top: 0.01rem;
      }
    }
  }

  .lottery-goods-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0.1rem;

    .lottery-good {
      display: flex;
      flex-direction: column;
      align-items: center;

      .lottery-img-container {
        background-color: #fff;
        display: flex;
        align-items: center;
        width: 0.64rem;
        height: 0.64rem;
        border-radius: 0.08rem;
        margin: 0 auto;
        position: relative;
        justify-content: center;
        overflow: hidden;

        .lottery-good-img {
          border-radius: 0.08rem;
          width: 100%;
          height: 100%;
          background-color: #fff;
          object-fit: contain;
        }

        .count-limit-container {
          overflow: hidden;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 0.04rem;
          max-width: 0.88rem;
          min-width: 0.4rem;
          height: 0.14rem;
          border-radius: 0.04rem;
          background-color: #fff2db;

          .count-limit {
            .ellipsis();

            max-width: 0.46rem;
            font-size: 0.1rem;
            color: #4d1b00;
            line-height: normal;
          }
        }
      }

      .lottery-good-info {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 0.06rem;
        max-width: 0.73rem;

        .good-name {
          .ellipsis();

          max-width: 0.7rem;
          line-height: 0.15rem;
          font-size: 0.11rem;
          font-weight: 600;
          color: #242729;
        }

        .good-button {
          position: relative;
          margin-top: 0.06rem;
          border-radius: 0.06rem;
          display: flex;
          // overflow: hidden;
          text-overflow: clip;
          min-width: 0.6rem;
          max-width: 0.7rem;
          height: 0.22rem;
          gap: 0.01rem;
          color: #fff;
          font-size: 0.12rem;
          font-weight: 500;
          line-height: 1;
          align-items: center;
          justify-content: center;
          background: linear-gradient(to right, rgba(255, 95, 93, 1), rgba(255, 78, 28, 1));

          .btn-text {
            .ellipsis();
          }

          &.disabled {
            background: #fda185;
          }

          &.black {
            background: #242729;
          }

          &.grey {
            background: #bcc4cc;
          }
        }

        .lock {
          position: absolute;
          right: -0.05rem;
          bottom: calc(0.22rem - 0.15rem / 2 - 0.02rem);
          height: 0.15rem !important;
          width: 0.13rem !important;
        }
      }
    }
  }
}
</style>
